export default "__VITE_ASSET__nrWg7cwM__"